import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { getConsent, loadTrackers } from "@/lib/track";

export function useSiteConfig() {
  const [config, setConfig] = useState(null);
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    let alive = true;
    http.get("/config").then(({ data }) => {
      if (!alive || !data) return;
      setConfig(data);
      const st = Date.parse(data?.server_time);
      if (!Number.isNaN(st)) setOffset(st - Date.now());
      if (getConsent() === "granted") loadTrackers(data?.tracking || {});
    }).catch(() => setConfig(false));
    return () => { alive = false; };
  }, []);
  return { config, offset };
}

export function useCountdown(target, offset) {
  const [now, setNow] = useState(() => Date.now() + offset);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now() + offset), 1000);
    return () => clearInterval(t);
  }, [offset]);
  const ts = Date.parse(target || "");
  const remaining = Number.isNaN(ts) ? 1 : ts - now;
  return { remaining, boarding: !Number.isNaN(ts) && remaining <= 0 };
}
